import { useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import { useFloorplanStore } from '@editor/stores'

const useFloorplanElementTypeToSelectable = (
  elementTypeToSelectable: Partial<Record<ElementTypes, boolean>> | null | undefined,
) => {
  const addElementTypeToSelectableGroup = useFloorplanStore(
    state => state.addElementTypeToSelectableGroup,
  )
  const removeElementTypeToSelectableGroup = useFloorplanStore(
    state => state.removeElementTypeToSelectableGroup,
  )

  useLayoutEffect(() => {
    if (!elementTypeToSelectable || Object.keys(elementTypeToSelectable).length === 0) return

    const uuidValue = v4()
    addElementTypeToSelectableGroup(uuidValue, elementTypeToSelectable)

    return () => {
      removeElementTypeToSelectableGroup(uuidValue)
    }
  }, [addElementTypeToSelectableGroup, removeElementTypeToSelectableGroup, elementTypeToSelectable])
}

export default useFloorplanElementTypeToSelectable
